/**
 * @generated SignedSource<<672a0d3fd265c9c9bc4aec7e8c3c132c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackTopicSelectField_user$data = {
  readonly isManager: boolean;
  readonly " $fragmentType": "FeedbackTopicSelectField_user";
};
export type FeedbackTopicSelectField_user$key = {
  readonly " $data"?: FeedbackTopicSelectField_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackTopicSelectField_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackTopicSelectField_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isManager",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7dc785c193c473276c42d47dff240bb1";

export default node;
